import React, { useState } from 'react';
import md5 from 'md5';
import './Md5Generator.css';

function Md5Generator() {
  const [inputText, setInputText] = useState('');
  const [md5Hash, setMd5Hash] = useState('');
  const [hashHistory, setHashHistory] = useState([]);
  const [toast, setToast] = useState({ show: false, message: '' });

  const handleGenerate = () => {
    if (inputText.trim()) {
      const hash = md5(inputText);
      setMd5Hash(hash);
      
      // 添加到历史记录
      setHashHistory(prev => {
        const newHistory = [{ text: inputText, hash }, ...prev];
        // 只保留最近的5条记录
        return newHistory.slice(0, 5);
      });
    }
  };

  const showToast = (message) => {
    setToast({ show: true, message });
    
    // 1秒后自动隐藏
    setTimeout(() => {
      setToast({ show: false, message: '' });
    }, 1000);
  };

  const handleCopyText = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        showToast(text + ' 已复制到剪贴板');
      })
      .catch(err => {
        console.error('复制失败:', err);
      });
  };

  const handleClearHistory = () => {
    setHashHistory([]);
  };

  return (
    <div className="md5-generator">
      {toast.show && (
        <div className="toast-message">
          {toast.message}
        </div>
      )}
      
      <h2>MD5生成器</h2>
      
      <div className="md5-container">
        <div className="generator-section">
          <div className="input-area">
            <textarea
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              placeholder="输入要生成MD5哈希的文本"
              rows={5}
            />
            <button 
              onClick={handleGenerate}
              className="generate-btn"
            >
              生成MD5
            </button>
          </div>
          
          {md5Hash && (
            <div className="result">
              <h3>MD5哈希结果:</h3>
              <div className="hash-result">
                <span className="hash-text">{md5Hash}</span>
                <button onClick={() => handleCopyText(md5Hash)} className="copy-btn">复制</button>
              </div>
            </div>
          )}
        </div>
        
        <div className="history-section">
          <div className="history-header">
            <h3>历史记录</h3>
            {hashHistory.length > 0 && (
              <button onClick={handleClearHistory} className="clear-btn">清除</button>
            )}
          </div>
          
          {hashHistory.length > 0 ? (
            <ul className="history-list">
              {hashHistory.map((item, index) => (
                <li key={index} className="history-item">
                  <div className="history-text">
                    <div className="text-content">
                      <strong>原文:</strong> {item.text.length > 32 ? `${item.text.substring(0, 32)}...` : item.text}
                    </div>
                    <button 
                      onClick={() => handleCopyText(item.text)} 
                      className="history-copy-btn"
                      title="复制原文"
                    >
                      复制
                    </button>
                  </div>
                  <div className="history-hash">
                    <div className="hash-content">
                      <strong>MD5:</strong> {item.hash}
                    </div>
                    <button 
                      onClick={() => handleCopyText(item.hash)} 
                      className="history-copy-btn"
                      title="复制MD5值"
                    >
                      复制
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div className="empty-history">
              <p>暂无历史记录</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Md5Generator; 